const koKR = {
    crossmintPayButtonService: {
        CONNECTING: "연결 중...",
        BUY: "크로스민트로 구매",
        BUY_WITH_ETH: "이더리움으로 구매",
        BUY_WITH_SOL: "솔라나로 구매",
        BUY_WITH_CREDIT_CARD: "신용카드로 구매",
    },
};
export default koKR;
